const BASE_URL = `https://dev-web.solar-manager.ch`;

const authorize = () => {
  window.location.href = `${BASE_URL}/basic/authorize`;
};

export default authorize;
